import React from 'react';
import FloatValidationLabel from './FloatValidationLabel';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';

const FormControl = ({ validationError, ...passThroughProps }) =>
    (
        <React.Fragment>
            <FloatValidationLabel validationError={validationError} />
            <Form.Control {...passThroughProps} />
        </React.Fragment>
    );


FormControl.propTypes = {
    validationError: PropTypes.string
};

export default FormControl;